import { AFSBrands, AFSCategories, AFSLifestyles, AFSLiveramp } from './static/format.js'

// sorted by UI order
export const TOP_LEVEL_FILTERS = {
  regions: "Regions",
  languages: "Page Content-Language",
  demographics: "Demographics",
  afs: "Affinity Solution",
  predictors: "Predictors",
}

export const DEFAULT_PERCENTILE = 100;

// names are the keys and proper values to be saved on audience object
export const AC_FILTERS = [
  {
    topLevel: TOP_LEVEL_FILTERS.regions,
    category: {
      label: 'Regions',
      name: 'regions',
    },
    getValues: (audience, { regions }) =>
      regions.map((value) => ({
        label: value.name,
        name: value.name,
        check: !!audience?.regions?.find?.((region) => region.name === value.name),
        saveValue: value,
      })),
  },
  {
    topLevel: TOP_LEVEL_FILTERS.languages,
    category: {
      label: 'Page Content-Language',
      name: 'languages',
    },
    getValues: (audience, { languages }) =>
      languages.map((value) => ({
        label: value.name,
        name: value.value,
        check: !!audience?.languages?.find?.((language) => language.value === value.value),
        saveValue: value,
      })),
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Age',
      name: 'ages',
    },
    values: [
      { label: '18 to 24', name: '18_24', check: null },
      { label: '25 to 34', name: '25_34', check: null },
      { label: '35 to 44', name: '35_44', check: null },
      { label: '45 to 54', name: '45_54', check: null },
      { label: '55 to 64', name: '55_64', check: null },
      { label: 'Greater than 64', name: 'gt_65', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Gender',
      name: 'genders',
    },
    values: [
      { label: 'Male', name: 'male', check: null },
      { label: 'Female', name: 'female', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Income',
      name: 'incomes',
    },
    values: [
      { label: 'Less than $30k', name: 'lt_30k', check: null },
      { label: '$30k to $50k', name: '30k_50k', check: null },
      { label: '$50k to $75k', name: '50k_74k', check: null },
      { label: '$75k to $100k', name: '75k_99k', check: null },
      { label: '$100k to $150k', name: '100k_150k', check: null },
      { label: 'Greater than $150k', name: 'gt_150k', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Dwelling Type',
      name: 'liDwellingType',
    },
    values: [
      { label: 'Single Family', name: 'single family', check: null },
      {
        label: 'Multi Family Dwelling/Apartment',
        name: 'multi family dwelling/apartment',
        check: null,
      },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Education',
      name: 'liEducation',
    },
    values: [
      { label: 'Doctorate/PhD or Above', name: 'doctorate/phd or above', check: null },
      { label: 'Completed Graduate School', name: 'completed graduate school', check: null },
      { label: 'Completed College', name: 'completed college', check: null },
      { label: 'Some College', name: 'some college', check: null },
      {
        label: 'Attended Vocational/Technical',
        name: 'attended vocational/technical',
        check: null,
      },
      { label: 'Completed High School', name: 'completed high school', check: null },
      { label: 'Some High School', name: 'some high school', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Home Ownership',
      name: 'liHomeOwner',
    },
    values: [
      { label: 'Home Owner', name: 'home owner', check: null },
      { label: 'Probable Home Owner', name: 'probable home owner', check: null },
      { label: 'Renter', name: 'renter', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Marital Status',
      name: 'liMaritalStatus',
    },
    values: [
      { label: 'Married', name: 'married', check: null },
      { label: 'Single', name: 'single', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Net Worth',
      name: 'liNetWorthHh',
    },
    values: [
      { label: 'Greater than $500k', name: 'j. greater than $499,999', check: null },
      { label: '$250k to $500k', name: 'i. $250,000 - $499,999', check: null },
      { label: '$100k to $250k', name: 'h. $100,000 - $249,999', check: null },
      { label: '$50k to $100k', name: 'g. $50,000 - $99,999', check: null },
      { label: '$25k to $50k', name: 'f. $25,000 - $49,999', check: null },
      { label: '$10k to $25k', name: 'e. $10,000 - $24,999', check: null },
      { label: '$5k to $10k', name: 'd. $5,000 - $9,999', check: null },
      { label: '$1k to $5k', name: 'c. $1 - $4,999', check: null },
      { label: 'Less than $1k', name: 'b. less than $1', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Occupation',
      name: 'liOccupationCategory',
    },
    values: [
      { label: 'Professional', name: 'professional', check: null },
      { label: 'White Collar Worker', name: 'white collar worker', check: null },
      { label: 'Blue Collar', name: 'blue collar', check: null },
      { label: 'Homemaker', name: 'homemaker', check: null },
      { label: 'Upper Management', name: 'upper management', check: null },
      { label: 'Lower Management', name: 'lower management', check: null },
      { label: 'Retired', name: 'retired', check: null },
      { label: 'Other', name: 'other', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Household Income',
      name: 'liIncomeHh',
    },
    values: [
      { label: 'Greater than $250k', name: 'o. $250k +', check: null },
      { label: '$200k to $250k', name: 'n. $200,000-$249,999', check: null },
      { label: '$175k to $200k', name: 'm. $175,000-$199,999', check: null },
      { label: '$150k to $175k', name: 'l. $150,000-$174,999', check: null },
      { label: '$100k to $150k', name: 'k. $100,000-$149,999', check: null },
      { label: '$75k to $100k', name: 'h. $75,000-$99,999', check: null },
      { label: '$60k to $75k', name: 'g. $60,000-$74,999', check: null },
      { label: '$50k to $60k', name: 'f. $50,000-$59,999', check: null },
      { label: '$40k to $50k', name: 'e. $40,000-$49,999', check: null },
      { label: '$30k to $40k', name: 'd. $30,000-$39,999', check: null },
      { label: '$20k to $30k', name: 'c. $20,000-$29,999', check: null },
      { label: '$10k to $20k', name: 'b. $10,000-$19,999', check: null },
      { label: 'Less than $10k', name: 'a. under $10,000', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Political Party',
      name: 'liPoliticalParty',
    },
    values: [
      { label: 'Republican', name: 'republican', check: null },
      { label: 'Democrat', name: 'democrat', check: null },
      { label: 'Independent', name: 'independent', check: null },
      { label: 'Conservative', name: 'conservative', check: null },
      { label: 'Libertarian', name: 'libertarian', check: null },
      { label: 'Liberal', name: 'liberal', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.afs,
    category: {
      label: 'Brands',
      name: 'afsBrand',
    },
    values: AFSBrands,
  },
  {
    topLevel: TOP_LEVEL_FILTERS.afs,
    category: {
      label: 'Categories',
      name: 'afsCategory',
    },
    values: AFSCategories,
  },
  {
    topLevel: TOP_LEVEL_FILTERS.afs,
    category: {
      label: 'Lifestyles',
      name: 'afsLifestyle',
    },
    values: AFSLifestyles,
  },
  {
    topLevel: TOP_LEVEL_FILTERS.afs,
    category: {
      label: 'LiveRamp',
      name: 'afsLiveramp',
    },
    values: AFSLiveramp,
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Amex Card Holder',
      name: 'liAmexCard',
    },
    values: [
      { label: 'amex card holder', name: 'amex card holder', check: null },
      { label: 'not amex card holder', name: 'not amex card holder', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Cat Owner',
      name: 'liCatOwner',
    },
    values: [
      { label: 'cat owner', name: 'cat owner', check: null },
      { label: 'not cat owner', name: 'not cat owner', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Children in Household',
      name: 'liChildrenHh',
    },
    values: [
      {
        label: 'presence of children in household',
        name: 'presence of children in household',
        check: null,
      },
      {
        label: 'no presence of children in household',
        name: 'no presence of children in household',
        check: null,
      },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Credit Card Holder',
      name: 'liCreditCard',
    },
    values: [
      { label: 'credit card holder', name: 'credit card holder', check: null },
      { label: 'not credit card holder', name: 'not credit card holder', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Dog Owner',
      name: 'liDogOwner',
    },
    values: [
      { label: 'dog owner', name: 'dog owner', check: null },
      { label: 'not dog owner', name: 'not dog owner', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Owns Investments',
      name: 'liOwnsInvestments',
    },
    values: [
      { label: 'owns investments', name: 'owns investments', check: null },
      { label: 'do not own investments', name: 'do not own investments', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Pet Owner',
      name: 'liPetOwner',
    },
    values: [
      { label: 'pet owner', name: 'pet owner', check: null },
      { label: 'not pet owner', name: 'not pet owner', check: null },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Premium Amex Card Holder',
      name: 'liPremiumAmexCard',
    },
    values: [
      {
        label: 'premium amex card holder',
        name: 'premium amex card holder',
        check: null,
      },
      {
        label: 'not premium amex card holder',
        name: 'not premium amex card holder',
        check: null,
      },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Premium Credit Card Holder',
      name: 'liPremiumCard',
    },
    values: [
      {
        label: 'premium credit card holder',
        name: 'premium credit card holder',
        check: null,
      },
      {
        label: 'not premium credit card holder',
        name: 'not premium credit card holder',
        check: null,
      },
    ],
  },
  {
    topLevel: TOP_LEVEL_FILTERS.demographics,
    category: {
      label: 'Owns Stocks and Bonds',
      name: 'liOwnsStocksAndBonds',
    },
    values: [
      {
        label: 'owns stocks and bonds',
        name: 'owns stocks and bonds',
        check: null,
      },
      {
        label: 'do not own stocks and bonds',
        name: 'do not own stocks and bonds',
        check: null,
      },
    ],
  },
]
